import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SelectOptionLayout, { SideItem } from '../../../../../layouts/components/SelectOptionLayout';
import DialogCancelarEnvio from '../../../paquetes/envios/DialogCancelarEnvio';
import PersonIcon from '@mui/icons-material/Person';
import DetailsIcon from '@mui/icons-material/Details';
import useAuth from '../../../../../hooks/useAuth';
import { useNavigate } from 'react-router';
import PaqDetalleEnvio from '../../../../../pages/dashboard/PaqDetalleEnvio';
import SectionCancelarEnvio from './SectionCancelarEnvio';
import SectionEliminarEnv from './SectionEliminarEnv';
import { providerAbrev } from '../../../../../utils/providerAbrev';

// function providerAbrev(val) {
//   const value = val.toLowerCase();
//   switch (value) {
//     case 'superenvios':
//       return 'SE';
//     case 'mienvio':
//       return 'MEM';
//     case 'redpack':
//       return 'Rk';
//     case 'ups':
//       return 'U';
//     default:
//       return '';
//   }
// }

function DialogEditarEnvio({ open, onClose, data = {} }) {
  const [section, setSection] = useState(1);
  const navigate = useNavigate();
  const { user } = useAuth();
  const { id, payment_id, rate_provider, trackingNumber, provider } = data;
  const prov = provider.split('/')[0];

  const handleClose = () => {
    onClose(false);
  };

  const showDetailsHandler = () => {
    navigate(
      `/dashboard/cotizaciones/administracion?id=${id}&payment_id=${payment_id}&provider=${provider}&paqueteria=${rate_provider}&codigo=${trackingNumber}`
    );
    setSection(2);
  };

  const side = (
    <>
      <SideItem
        text="Detalles"
        section={1}
        action={setSection}
        // priorityAction={showDetailsHandler}
        icon={<DetailsIcon />}
      />
      <SideItem text="Cancelar envio" section={2} action={setSection} icon={<PersonIcon />} />
      {/* <SideItem text="Eliminar" section={3} action={setSection} icon={<PersonIcon />} /> */}
    </>
  );

  const body = (
    <>
      {section === 1 && (
        <Grid item xs={12}>
          <PaqDetalleEnvio />
        </Grid>
      )}
      {section === 2 && (
        <>
          <Grid item xs={12}>
            <SectionCancelarEnvio data={data} dataAdmin={user} />
          </Grid>
        </>
      )}
      {/* {section === 3 && (
        <Grid item xs={12}>
          <SectionEliminarEnv dataEnvio={data} />
        </Grid>
      )} */}
    </>
  );

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ textAlign: 'center' }} id="alert-dialog-title">
        {providerAbrev(prov)} - {rate_provider}
      </DialogTitle>
      <DialogContent>
        <SelectOptionLayout sidebar={side} body={body} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogEditarEnvio;
